module.exports = __webpack_public_path__ + "static/screencapture-chooseaxis-2019-06-01-19_04_17-091b7fa8b89ecaa7ab0fc5bdf2205d52.png";